const currentHash = window.location.hash;
if (currentHash.length > 0) {
  setTimeout(() => {
    // Remove the hash
    window.location.hash = "";
    // Add the hash back
    window.location.hash = currentHash;
  }, 50);
}
